import React from "react";
import { Link } from "react-router-dom";
import { Dumbbell, Home, Search } from "lucide-react";
import SEOHead from "@/components/SEOHead";

export default function NotFoundPage() {
  return (
    <div className="container-fl py-24 text-center max-w-lg" data-testid="not-found-page">
      <SEOHead title="Page not found" noIndex/>
      <div className="w-20 h-20 rounded-full bg-neutral-100 grid place-items-center mx-auto mb-6">
        <Dumbbell size={32} className="text-neutral-400"/>
      </div>
      <div className="text-7xl font-black tracking-tighter text-emerald-600">404</div>
      <h1 className="text-3xl font-black tracking-tighter mt-2 mb-3">Missed rep. Page not found.</h1>
      <p className="text-neutral-600 mb-8">
        The page you're looking for has moved, been deleted, or never existed. Let's get you back to the marketplace.
      </p>
      <div className="flex gap-3 justify-center">
        <Link to="/" className="btn-secondary" data-testid="404-home"><Home size={14}/> Homepage</Link>
        <Link to="/trainers" className="btn-primary" data-testid="404-trainers"><Search size={14}/> Find trainers</Link>
      </div>
    </div>
  );
}
